import { tasks, properties, agents } from './entities'
import * as R from 'ramda'
import createSelector from 'utils/redux/createSelector' // import { createSelector } from 'reselect'

let agentsFilters = state => state.agentsFilters

let filteredAgents = (agentsFilters) => (agent) => {
	if(!agent) return false
	if(agentsFilters.property != 'All' && agent.distance && agent.distance >= 50) return false
	if(agentsFilters.type != 'All' && agentsFilters.type != '' && agent.agentType == agentsFilters.type) return false
	return true
}

export default createSelector(
	[properties, tasks, agents, agentsFilters]
  , (properties, tasks, agents, agentsFilters) => R.filter(
			filteredAgents(agentsFilters)
		  , R.map(agent => ({
				...agent
			  , tasksActive: R.values(R.filter(task => !!~agent.tasks.indexOf(task._id) && !task.done, tasks))
			  , tasksDone: R.values(R.filter(task => !!~agent.tasks.indexOf(task._id) && task.done, tasks))
			  , distance: (() => {
					if(
						!!properties[agentsFilters.property]
						&& !!agent.cors
						&& !!properties[agentsFilters.property].cors
						&& properties[agentsFilters.property].cors.lat != ''
						&& properties[agentsFilters.property].cors.lat != ''
					){
					  	let R = 3958.756;
					  	let dLat = (properties[agentsFilters.property].cors.lat-agent.cors.lat)* Math.PI / 180;
					  	let dLon = (properties[agentsFilters.property].cors.lng-agent.cors.lng)* Math.PI / 180;
					  	let lat1 = agent.cors.lat * Math.PI / 180;
					  	let lat2 = properties[agentsFilters.property].cors.lat * Math.PI / 180;

					  	let a = Math.sin(dLat/2) * Math.sin(dLat/2) +
					  			Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2);
					  	let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
					  	let d = R * c / 1.60934;
						return d.toFixed(2)
					} else {
						return 0
					}
			  })()
			})
		  , agents
		)
	)
)

// export let agents = (state) => R.filter(filteredAgents(state), R.map(exAgent(state), getByType(state, 'agent')))



// WEBPACK FOOTER //
// ./src/selectors/agents.js